const config = {
  API_URL: import.meta.env.VITE_API_URL || 'https://spacemeet.ru/vk-land',
}

export default config
